module.exports = __webpack_public_path__ + "img/Logo_EU.cdabf776.svg";